import axiosInstance from '../api/axios';

export const dictionariesService = {
  getCurrencies: async () => {
    const res = await axiosInstance.get('finance/currencies');
    return res.data;
  },
  getPaymentSystems: async () => {
    const res = await axiosInstance.get('finance/payment-systems');
    return res.data;
  },
  getCountries: async () => {
    const res = await axiosInstance.get('finance/countries');
    return res.data;
  },
  getBanks: async () => {
    const res = await axiosInstance.get('finance/banks');
    return res.data;
  },

  // Методы для валют
  createCurrency: async (data: any) => {
    const res = await axiosInstance.post('finance/currencies', data);
    return res.data;
  },
  updateCurrency: async (id: string, data: any) => {
    const res = await axiosInstance.put(`finance/currencies/${id}`, data);
    return res.data;
  },
  deleteCurrency: async (id: string) => {
    const res = await axiosInstance.delete(`finance/currencies/${id}`);
    return res.data;
  },

  // Методы для стран
  createCountry: async (data: any) => {
    const res = await axiosInstance.post('finance/countries', data);
    return res.data;
  },
  updateCountry: async (id: string, data: any) => {
    const res = await axiosInstance.put(`finance/countries/${id}`, data);
    return res.data;
  },
  deleteCountry: async (id: string) => {
    const res = await axiosInstance.delete(`finance/countries/${id}`);
    return res.data;
  },

  // Методы для платежных систем
  createPaymentSystem: async (data: any) => {
    const res = await axiosInstance.post('finance/payment-systems', data);
    return res.data;
  },
  updatePaymentSystem: async (id: string, data: any) => {
    const res = await axiosInstance.put(`finance/payment-systems/${id}`, data);
    return res.data;
  },
  deletePaymentSystem: async (id: string) => {
    const res = await axiosInstance.delete(`finance/payment-systems/${id}`);
    return res.data;
  },

  // Методы для банков
  createBank: async (data: any) => {
    const res = await axiosInstance.post('finance/banks', data);
    return res.data;
  },
  updateBank: async (id: string, data: any) => {
    const res = await axiosInstance.put(`finance/banks/${id}/`, data);
    return res.data;
  },
  deleteBank: async (id: string) => {
    const res = await axiosInstance.delete(`finance/banks/${id}`);
    return res.data;
  },
};

export const getDictionaries = async () => {
  const response = await axiosInstance.get('/dictionaries');
  return response.data;
};

export const getDictionaryById = async (id: string) => {
  const response = await axiosInstance.get(`/dictionaries/${id}/`);
  return response.data;
};

export const createDictionary = async (dictionaryData: any) => {
  const response = await axiosInstance.post('/dictionaries', dictionaryData);
  return response.data;
};

export const updateDictionary = async (id: string, dictionaryData: any) => {
  const response = await axiosInstance.put(`/dictionaries/${id}/`, dictionaryData);
  return response.data;
};

export const deleteDictionary = async (id: string) => {
  const response = await axiosInstance.delete(`/dictionaries/${id}/`);
  return response.data;
}; 